import React from "react";

const StaffProfileAssignPatient = ({ staff }) => {
	return (
		<>
			<div className="row">
				<div className="profile-userpic">
					<center>
						<div
							style={{
								backgroundImage: `url(${staff.image ||
									`https://dummyimage.com/80x80&text=${staff.surname}`}`,
								width: "100px",
								height: "100px"
							}}
							className="img-container user-img-circle"
						></div>
					</center>
				</div>
			</div>
			<div className="profile-usertitle">
				<div className="profile-usertitle-name">
					{staff.first_name} {staff.middle_name} {staff.surname}
				</div>
				<div className="profile-usertitle-job">
					Designation:
					<strong className="text-success">
						{staff.designation.name}
					</strong>
				</div>
			</div>
			<ul className="list-group list-group-unbordered">
				<li className="list-group-item">
					<b>Email</b>{" "}
					<label className="pull-right">{staff.email}</label>
				</li>
				<li className="list-group-item">
					<b>Phone No</b>
					<label className="pull-right">{staff.mobile}</label>
				</li>
				<li className="list-group-item">
					<b>Gender</b>{" "}
					<label className="pull-right">{staff.gender}</label>
				</li>
				<li className="list-group-item">
					<b>Post Code</b>{" "}
					<label className="pull-right">
						{staff.postal_code || "Nil"}
					</label>
				</li>
				<li className="list-group-item">
					<b>Contact Address</b>{" "}
					<label className="pull-right">
						{staff.contact_address || "Nil"}
					</label>
				</li>
			</ul>
			{/* labels for list of assigned patients */}
			{staff.patients.length > 0 && (
				<div className="profile-userbuttons">
					<p>List of Assigned Patients</p>
					<div className="row col-lg-12">
						{staff.patients.map(patient => (
							<div
								key={patient.id}
								className="col-lg-6 col-md-3 col-xs-12 tooltiptrigger"
							>
								{/* <!-- Contact Chip --> */}
								<span className="mdl-chip mdl-chip--contact">
									<img
										alt={patient.name}
										className="mdl-chip__contact"
										src={patient.profile_picture}
									/>
									<span className="mdl-chip__text">
										{patient.name}
									</span>
								</span>
							</div>
						))}
					</div>
				</div>
			)}
			{/* <!-- END SIDEBAR BUTTONS --> */}
		</>
	);
};

export default StaffProfileAssignPatient;
